import React, { Fragment } from 'react'
import Api from 'Api'
import ReactDOM from "react-dom";
import { I18nextProvider, translate } from 'react-i18next'
import i18n from './../locale'


class Contact extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showModal: false,
            showSecondModal: false,
            modalError: false,
            name: '',
            email: '',
            message: ''
        }
    }

    handleShowModal = () => {
        this.setState({
            showModal: !this.state.showModal,
            showSecondModal: false,
            modalSuccess: false
        })
    }
    onChange = (e) => {
        this.setState({ [e.target.id]: e.target.value })
    }
    closeModal = () => {
        this.setState({
            showModal: false,
            showSecondModal: false,
            modalError: false
        })
    }
    handleSubmit = async (e) => {
        e.preventDefault()
        const { name, email, message } = this.state
        if (name && email && message) {
            try {
                const resp = await Api.post("/contacts", { name, email, message });
                this.setState({ showSecondModal: true })
            } catch (error) {
                this.setState({ showSecondModal: true, modalError: true })
            }

        } else { }
    }
    render() {
        const { showModal, showSecondModal, modalError, name, email, message } = this.state
        const { t } = this.props
        return (<Fragment>
            <p className="contact-trigger" onClick={this.handleShowModal}>
                {t('footer.contact')}
            </p>
            <div id="contact-modal" onClick={(e) => { e.target.id == 'contact-modal' ? this.handleShowModal() : '' }} className={showModal ? 'contact-modal__active' : 'contact-modal'} >
                <div className={showSecondModal ? 'd-none' : "contact-modal-form"}>
                    <h5>Contact Us</h5>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam</p>
                    <form onSubmit={this.handleSubmit}>
                        <input
                            placeholder="Enter your fullname"
                            type="text"
                            id='name'
                            value={name}
                            onChange={this.onChange}
                        />
                        <input
                            placeholder="Enter your email"
                            type="email"
                            id='email'
                            value={email}
                            onChange={this.onChange}
                        />
                        <textarea
                            value={message}
                            id='message'
                            row="3"
                            placeholder="Enter your message"
                            onChange={this.onChange}
                        ></textarea>
                        <input type="submit" value="SEND" />
                    </form>
                </div>
                <div className={showSecondModal ? "contact-modal-confirmation" : 'd-none'}>
                    <div><img src='/assets/img/icon/checkmark.svg' /></div>
                    <h5>{modalError ? 'Message Failed!' : 'Message Sent!'}</h5>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam</p>
                    <input type='button' value='OK' onClick={this.closeModal} />
                </div>
            </div>
        </Fragment>
        )
    }
}


const Translated = translate('translation')(Contact)
ReactDOM.render(
    <I18nextProvider i18n={i18n}>
        <Translated />
    </I18nextProvider>
    , document.getElementById('contact-react'))


// WEBPACK FOOTER //
// ./assets/js/components/contact.js